import { Checkbox as FuseCheckbox } from '@tvg/fuse/checkbox';
import { getEncodeId } from 'client/utils/utils';
import React, { FormEventHandler, useMemo } from 'react';
import styles from './Checkbox.module.css';

function Checkbox({
  checked,
  name,
  onChange,
  ...props
}: {
  error: boolean;
  name: string;
  value: string;
  checked: boolean;
  fullWidth?: boolean;
  componentId?: string;
  dataTestId?: string;
  onChange: FormEventHandler<HTMLElement>;
  marginBottom?: boolean;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLInputElement>) {
  const encodedName = useMemo(() => getEncodeId(name), [name]);
  return (
    <FuseCheckbox name={encodedName} isChecked={checked} onChange={onChange} {...props} className={styles.checkbox} />
  );
}

export default React.memo(Checkbox);
